import { IFilterSelectorSchema } from '../../repositories/newbuilding-promos/entities/filter_selector/FilterSelectorSchema';

import { EType } from '../../repositories/newbuilding-promos/entities/json_query/IntTermFieldSchema';
import { EValue } from '../../repositories/newbuilding-promos/entities/json_query/PromoTypeTermsFieldSchema';

export const getFilterSelectorsMk = (): IFilterSelectorSchema[] => {
  return [
    {
      name: 'Ипотека',
      jsonQuery: {
        promoType: {
          type: EType.Terms,
          value: [EValue.Mortgage],
        },
      },
    },
    {
      name: 'Скидка',
      jsonQuery: {
        promoType: {
          type: EType.Terms,
          value: [EValue.Discount],
        },
      },
    },
    {
      name: 'Военная ипотека',
      jsonQuery: {
        promoType: {
          type: EType.Terms,
          value: [EValue.Military],
        },
      },
    },
  ];
};
